<template>
  <div class="bg_Login" :style="{ 'backgroundImage': 'url(' + urlIcon + ')' }">
    <div class="bg_wrap">
      <div class="bg_count">
        <div class="bg_color">
          <img src="@/assets/img/enjiu.png" class="img1" />
          <div class="title">欢迎登录智慧教学综合门户</div>

          <el-form :model="dataForm"  ref="loginForm" @keyup.enter.native="dataFormSubmit()" class="form_ls">
            <el-form-item prop="account">
              <el-input @focus="isError=false" v-model="dataForm.account" placeholder="请输入工号/学号" maxlength="30">
                <template slot="prepend"><img :src="isTrue ? imgUser2 : imgUser"></template>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input @focus="isError=false" v-model="dataForm.password" show-password maxlength="30"
                type="password" placeholder="请输入密码">
                <template slot="prepend"><img :src="isTrue2 ? imgSuo2 : imgSuo"></template>
              </el-input>
            </el-form-item>
            <div class="error">
                <div v-if="isError">账户密码不能为空</div>
            </div>
            <el-form-item>
              <el-button class="login-btn-submit" type="primary" @click="dataFormSubmit()" >登录
              </el-button>
            </el-form-item>

            <!-- 新增钉钉授权登录按钮 -->
            <el-form-item>
              <div  style="display: inline-flex; align-items: center;">快捷登录：<img src="@/assets/img/dingtalk.png" alt="钉钉" title='钉钉授权登录' style="width: 40px; cursor: pointer;" @click="getDingTalkAuthUrl()"></div>
            </el-form-item>


          </el-form>





        </div>
      </div>
    </div>
    <div class="foot">
      为了获得最佳浏览效果，建议在分辨率大于或等于1024*768的屏幕下浏览网站
      <a href="https://www.google.cn/chrome/" target="_blank">
        <span>建议使用谷歌浏览器</span>
      </a>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import imgUser from '../assets/img/zh.png'
import imgSuo from '../assets/img/mm.png'
import imgUser2 from '../assets/img/zh.png'
import imgSuo2 from '../assets/img/mm.png'
import { loginByAccount, loginByPcOpenid, queryUserByOpenCode, resetPassword ,getAuthUrlByDingTalk} from '@/api/api'
import { setLoginInfo, clearLoginInfo } from '@/utils'
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      console.warn(value)
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (!/^.*(?=.{6,})(?=.*\d)(?=.*[a-z]).*$/.test(value)) {
        callback(new Error('密码需要6位以上位字母和数字'))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.resetPasswordForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      urlIcon: require("@/assets/img/bg.jpg"),
      typeList: ['账号登录'],
      typeIndex: 0,
      accountShow: true,
      imgUser: imgUser,
      imgSuo: imgSuo,
      imgUser2: imgUser2,
      imgSuo2: imgSuo2,
      code: '',
      resetPasswordForm: {
        wxVisible: false,
        passwordVisible: false,
        redirect_uri: 'http://jbzk.ejkj.top?returnType=resetPassword',
        userId: '',
        password: '',
        checkPass: ''
      },
      dataForm: {
        account: '',
        password: '',
        uuid: '',
        captcha: '1111'
      },
      dataRule: {
        account: [
          { required: true, message: '帐号不能为空', trigger: 'blur' },
          { max: 20, message: '账号长度不能超过20个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      },
      isTrue: true,
      isTrue2: true,
      appid: process.env.WX_APPID,
      redirect_uri: 'http://jbzk.ejkj.top?returnType=login',
      rules: {
        password: [
          { validator: validatePass, trigger: 'blur', required: true }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur', required: true }
        ]
      },
      isError:false
    }
  },
  mounted() {
    if (typeof this.$route.query.returnType != 'undefined') {
      let returnType = this.$route.query.returnType
      this.code = this.$route.query.code
      if (returnType == 'login') {
        //微信登录
        this.accountShow = false
        this.loginMode(1)
        this.loginByPcOpenid()
      } else if (returnType == 'resetPassword') {
        //忘记密码
        this.queryUserByOpenCode()
      }
    }
  },
  methods: {
    loginMode(index) {
      this.typeIndex = index
      switch (index) {
        case 0:
          this.accountShow = true;
          break;
        case 1:
          this.accountShow = false;
      }
    },
    loginByPcOpenid() {
      loginByPcOpenid({
        code: this.code
      }).then(res => {
        if (res && res.code === 0) {
          this.$message.success("登录成功")
          setLoginInfo(res.data)
          this.$router.push({ path: '/home' })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 新增获取钉钉授权URL的方法
    getDingTalkAuthUrl() {
      getAuthUrlByDingTalk().then(response => {
          const authUrl = response.data; 
          window.location.href = authUrl;
      })
      .catch(error => {
          this.$message.error('获取钉钉授权URL失败，请稍后重试');
          console.error(error);
      });     
    },


    dataFormSubmit() {
      if(this.dataForm.account == ''||this.dataForm.password == ''){
          this.isError = true
      }else{
        this.doLogin()
      }
      // this.$refs['loginForm'].validate((valid) => {
      //   if (valid) {
   

      //     this.doLogin()
      //   }
      // })
    },
    // 加密
    doLogin() {
      // var  pubkeyHex='04bf98eaf6fd1b417477be289bd4708942fe9aba5fc71dfd143955e019b4386baa6610765da075e2d77a7e547c795bf8e3ff295b280ffdd874e4c771255d713916';
      // let newForm = JSON.parse(JSON.stringify(this.dataForm))
      // newForm.password = sm2.doEncrypt(this.dataForm.password, pubkeyHex);
      loginByAccount(this.dataForm).then(res => {
        if (res && res.code === 0) {
          this.$message.success("登录成功")
          setLoginInfo(res.data)
          // Vue.cookie.set('psw', window.btoa(this.dataForm.password)) // base64加密
          this.$router.push({ path: '/home' })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    fogetPassword() {
      this.resetPasswordForm.wxVisible = true
      // this.resetPassword.passwordVisible = true
    },
    queryUserByOpenCode() {
      loginByPcOpenid({
        code: this.code
      }).then(res => {
        if (res && res.code === 0) {
          setLoginInfo(res.data)
          this.resetPasswordForm.wxVisible = false
          this.resetPasswordForm.passwordVisible = true
          this.resetPasswordForm.userId = res.data.userId
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    resetPassword() {
      resetPassword(this.resetPasswordForm).then(res => {
        if (res && res.code === 0) {
          this.$message.success('密码重置成功,请登录')
          clearLoginInfo()
          this.resetPasswordForm.passwordVisible = false
          this.resetPasswordForm.wxVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    submitForm() {
      this.$refs['resetPasswordForm'].validate((valid) => {
        if (valid) {
          this.resetPassword()
        }
      })
    }

  },
}
</script>
<style scoped lang="scss">
.bg_Login {
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.foot {
  font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #333333;
line-height: 14px;
  margin-bottom: 30px;
}
.foot a{
  font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #333333;
line-height: 14px;
margin-left: 20px;

}

.bg_wrap {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
}

.bg_count {
  width: 980px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bg_color {
  width: 380px;
  height: 410px;
  background: #FFFFFF;
  border-radius: 18px 18px 18px 18px;
  display: flex;
  flex-direction: column;
  padding: 60px 60px 80px 60px;
  align-items: center;
}

.img1 {
  height: 44px;
  width: auto;
}

.title {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 26px;
  color: #11202D;
  line-height: 30px;
  margin-top: 40px;
  margin-bottom: 40px;
}
.error{
  color: red;
  height: 20px;
  line-height: 20px;
  text-align: left;
}
.login-btn-submit{
  margin-top: 30px;
  width: 100%;
  height: 50px;
  background: #1573FC;
  border-radius: 5px 5px 5px 5px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
}

</style>


// WEBPACK FOOTER //
// src/views/login.vue